import EducationCareerTab from './EducationCareerTab';

export default EducationCareerTab;
